require('./videoAnalysisController');
require('./tabs/myClips/myClips');
require('./tabs/filterForm/filterForm');

angular.module('app.admin.videoAnalysis', [
  'app.admin.videoAnalysis.videoAnalysisController',
  'app.admin.videoAnalysis.tabs.myClips',
  'app.admin.videoAnalysis.tabs.filterForm'
])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      "use strict";

      $stateProvider.state(
        'app.admin.videoAnalysis',
        {
          abstract: true,
          url: '/video-analysis',
          templateUrl: 'components/admin/videoAnalysis/videoAnalysisView.html',
          controller: 'app.admin.videoAnalysis.videoAnalysisController',
          title: 'Video Analysis'
        }
      )
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/videoAnalysis.js